"use client-entry";

import { hydrate } from '@parcel/rsc/client';

// Google Analytics
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-W8PJRWMR5Q';
document.head.appendChild(gtagScript);

const gtagConfig = document.createElement('script');
gtagConfig.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-W8PJRWMR5Q');
`;
document.head.appendChild(gtagConfig);

hydrate();
